import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AnimatePresence } from 'framer-motion';
import { useCallback, useRef } from 'react';
import getElementInset from '../helpers/getElementInset';
import useRouter from '../hooks/useRouter';
import useWindowSize from '../hooks/useWindowSize';
import DesktopNavigation from './DesktopNavigation';
import MapLayer from './MapLayer';
import MobileNavigation from './MobileNavigation';
const MARKER_AREA_SIZE_THRESHOLD = 150;
const MapUI = ({ map, routes, includeMajorCities }) => {
    const nav = useRouter(routes);
    const windowSize = useWindowSize();
    const refMarkerArea = useRef(null);
    const getMarkerAreaBounds = useCallback((action) => {
        const elem = refMarkerArea.current;
        if (elem) {
            const inset = getElementInset(elem, 3);
            if (action === 'center' ||
                (inset.width >= MARKER_AREA_SIZE_THRESHOLD &&
                    inset.height >= MARKER_AREA_SIZE_THRESHOLD)) {
                return inset;
            }
        }
        // If we can't find the positioning element,
        // fall back to passable defaults
        return {
            left: 20,
            top: 60,
            right: 20,
            bottom: 20,
        };
    }, [refMarkerArea, windowSize]);
    return (_jsxs("div", { className: "absolute inset-0 flex flex-col overflow-hidden pointer-events-none", children: [_jsxs("div", { className: "flex flex-col flex-grow mt-6 corridor tablet-portrait:mt-16 laptop:flex-row", children: [_jsx(AnimatePresence, { exitBeforeEnter: true, children: _jsx(MapLayer, { map: map, route: nav.route, direction: nav.direction, getBounds: getMarkerAreaBounds, includeMajorCities: includeMajorCities }, nav.route.path) }), _jsx("div", { className: "relative flex-grow min-h-0 overflow-hidden", children: _jsx("div", { ref: refMarkerArea, className: "absolute bottom-0 left-4 right-4 top-16 tablet-portrait:bottom-4 laptop:l-6 laptop:right-12 laptop:top-16 laptop:bottom-6" }) })] }), routes.length > 1 && _jsxs("div", { className: "z-10 flex-shrink-0 w-full tablet-portrait:mb-8", children: [_jsx("div", { className: "tablet-portrait:hidden", children: _jsx(MobileNavigation, { nav: nav }) }), _jsx("div", { className: "hidden tablet-portrait:block", children: _jsx(DesktopNavigation, { nav: nav }) })] })] }));
};
export default MapUI;
